import type { AccountProfileResponseV2Dto } from '../../resources/@types/accountSchema';

export const getB2BRole = (profile: AccountProfileResponseV2Dto | null) => {
  if (!profile) {
    return {
      isB2BUser: false,
      isGroupManager: false,
      isGroupMember: false,
    };
  }

  const { managedGroup, group } = profile;

  const isGroupMember = !!group?.id;
  const isGroupManager = !!managedGroup?.id;

  const isB2BUser = isGroupMember || isGroupManager;

  return {
    isB2BUser,
    isGroupManager,
    isGroupMember,
  };
};
